<template>
  <div>

    <CRow>
      <CCol md="12">


        <CRow>
          <CCol col="6">
            <CCard>
              <CCardHeader>

                <CRow>
                  <CCol col="8" style="text-align: start">

                    <strong>{{ $t('components.accountingGroups') }}</strong>

                  </CCol>
                  <CCol col="4" style="text-align: end">

                    <CButton
                        @click="get_template_view_pdf(5)"
                        color="secondary"
                    >{{ $t("ExportData") }}</CButton>

                  </CCol>

                </CRow>

              </CCardHeader>
              <CCardBody style="margin-bottom: 30px">
                <!--            <TreeView :tree="tree" :icons="icons" />-->
                <v-jstree oncontextmenu="return false" v-if="data_accounting.length>0" :data="data_accounting"
                          :klass="tree_view_direction()"
                          :item-events="itemEvents" :collapse="collapse_tree" allow-batch whole-row
                          @item-click="itemClick"
                ></v-jstree>


              </CCardBody>
            </CCard>
          </CCol>
          <CCol col="6">
            <CCard v-if="selected_node_floor ==2 ">
              <CCardHeader>

                <CRow>
                  <CCol col="8" style="text-align: start">
                    <strong>{{$t('tafsiliList')}}</strong>

                  </CCol>
                  <CCol col="4" style="text-align: end">
                    <strong>
                      <CIcon v-if="!blocked_moein.includes(edit_refer_person)" name="cil-plus"
                             @click.native="add_tafzili(item)"/>
                    </strong>
                  </CCol>

                </CRow>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol col="12">
                    <label v-if="(blocked_moein.includes(edit_refer_person) || blocked_moein.includes(edit_refer_person_node))" class="text-danger">{{$t('tafsiliLocationDoc')}}</label>

                    <CDataTable
                        :items="tafzili_list"
                        :fields="tafzili_fields"
                        striped
                        border
                        style="height: 400px;overflow: auto"
                        :items-per-page="200"
                        hover
                        pagination
                    >
                      <template #row="{item,index}">
                        <td>{{ index + 1 }}</td>
                      </template>

                      <template #operation="{item,index}">
                        <td>
                          <CIcon @click.native="edit_tafzili(item)" class="text-primary mr-1 ml-1" name="cil-pencil"/>

                          <CIcon @click.native="delete_item_dialog(item)" class="text-danger" name="cilTrash"/>

                        </td>
                      </template>
                    </CDataTable>

<!--                    <label>{{ selected_node_parents }} -</label>-->
<!--                    {{ selected_node_name }}-->
<!--                    <CRow>-->
<!--                      <CCol col="10">-->

<!--                        <CInput-->
<!--                            :label="$t('components.groupName')"-->
<!--                            :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"-->


<!--                            v-model="edit_group_name"-->
<!--                        />-->
<!--                        <CSelect-->
<!--                            label="ماهیت"-->
<!--                            v-model="group_type"-->
<!--                            :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"-->

<!--                            :options="items_types"-->
<!--                        />-->
<!--                        <CInput-->
<!--                            :label="$t('components.tax')"-->
<!--                            :horizontal="{label: 'col-sm-3', input: 'col-sm-3'}"-->


<!--                            v-model="group_vat"-->
<!--                        />-->
<!--                        <CRow class="form-group form-row">-->
<!--                          <CCol col="3" style="text-align: end">-->
<!--                            <label>{{ $t('components.visibility') }}</label>-->
<!--                          </CCol>-->
<!--                          <CCol col="9">-->
<!--                            &lt;!&ndash;                            <CInputCheckbox&ndash;&gt;-->
<!--                            &lt;!&ndash;                                custom&ndash;&gt;-->
<!--                            &lt;!&ndash;:checked.sync="edit_group_visibility"&ndash;&gt;-->
<!--                            &lt;!&ndash;                            />&ndash;&gt;-->
<!--                            <CIcon-->
<!--                                @click.native="edit_group_visibility = 0"-->
<!--                                v-if="edit_group_visibility==1"-->
<!--                                class="text-success" name="cil-check"/>-->
<!--                            <CIcon-->
<!--                                @click.native="edit_group_visibility=1"-->
<!--                                v-else-->
<!--                                name="cil-check"/>-->

<!--                          </CCol>-->
<!--                        </CRow>-->
<!--                        <CSelect-->
<!--                            :label="$t('components.groupNature')"-->
<!--                            :options="items_natures"-->
<!--                            horizontal-->
<!--                            v-show="false"-->
<!--                            :value.sync="edit_group_nature"-->
<!--                        />-->

<!--                        <CInput-->
<!--                            type="number"-->
<!--                            :label="$t('components.groupCode')"-->
<!--                            horizontal-->
<!--                            v-show="false"-->

<!--                            v-model="edit_group_code"-->
<!--                        />-->


<!--                      </CCol>-->
<!--                    </CRow>-->
<!--                    <CRow class="text-center">-->
<!--                      <CCol style="    text-align: end;">-->

<!--                        <CButton @click="edit_data()"-->
<!--                                 class="m-1"-->
<!--                                 color="secondary"-->
<!--                        >{{ $t("buttons.edit") }}-->
<!--                        </CButton>-->
<!--                        <CButton v-if="!blocked_moein.includes(edit_refer_person)" @click="insert_data()" class="m-1"-->
<!--                                 color="secondary"-->
<!--                        >{{ $t("buttons.add") }}-->
<!--                        </CButton>-->
<!--                        <CButton class="m-1"-->
<!--                                 @click="addGroupModal = false,status_form= 0"-->
<!--                                 color="secondary"-->
<!--                        >{{ $t("buttons.cancel") }}-->
<!--                        </CButton>-->
<!--                      </CCol>-->
<!--                    </CRow>-->


                  </CCol>
                </CRow>


              </CCardBody>
            </CCard>
          </CCol>

        </CRow>

      </CCol>

    </CRow>

    <vue-context ref="menu" class="m-0 p-0">
      <li class="m-0  p-0">
        <a href="#" @click.prevent="onClick_context('edit')">{{$t('addEdit')}}</a>
      </li>
    </vue-context>

    <CModal
        :show.sync="addGroupModal"
        :no-close-on-backdrop="true"
        color="dark"
        :title="$t('addEdit')"
    >

      <CRow>
        <CCol col="12">
          <CInput
              :label="$t('components.groupName')"
              :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"


              v-model="edit_group_name"
          />

          <CSelect
              :label="$t('accountSarfasl')"
              :options="items_tafsili_types"
              horizontal
              :value.sync="edit_group_tafsili_type"
          />
          <CSelect
              :label="$t('nature')"
              :value.sync="edit_group_nature"
              :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"

              :options="items_natures"
          />
          <CInput
              :label="$t('components.tax')"
              :horizontal="{label: 'col-sm-3', input: 'col-sm-3'}"
              append="%"
              addInput
              addInputClasses="text-end"

              v-model="group_vat"
          />
          <CRow class="form-group form-row">
            <CCol col="3" style="text-align: end">
              <label>{{ $t('components.visibility') }}</label>
            </CCol>
            <CCol col="9">
              <!--                            <CInputCheckbox-->
              <!--                                custom-->
              <!--:checked.sync="edit_group_visibility"-->
              <!--                            />-->
              <CIcon
                  @click.native="edit_group_visibility = 0"
                  v-if="edit_group_visibility==1"
                  class="text-success" name="cil-check"/>
              <CIcon
                  @click.native="edit_group_visibility=1"
                  v-else
                  name="cil-check"/>

            </CCol>
          </CRow>
          <CSelect
              :label="$t('components.groupNature')"
              :options="items_natures"
              horizontal
              v-show="false"
              :value.sync="edit_group_nature"
          />

          <CInput
              type="number"
                      v-on:keypress="isNumber($event)"
              :label="$t('components.groupCode')"
              horizontal
              v-show="false"

              v-model="edit_group_code"
          />


        </CCol>
      </CRow>
      <template #footer>
        <CRow class="text-center">
          <CCol style="    text-align: end;">

            <CButton @click="edit_data()"
                     class="m-1"
                     color="secondary"
            >{{ $t("buttons.edit") }}
            </CButton>
            <CButton v-if="(!blocked_moein.includes(edit_refer_person) && !blocked_moein.includes(edit_refer_person_node)) && selected_node_floor<2" @click="insert_data()" class="m-1"
                     color="secondary"
            >{{ $t("buttons.add") }}
            </CButton>
            <CButton class="m-1"
                     @click="addGroupModal = false,status_form= 0"
                     color="secondary"
            >{{ $t("buttons.cancel") }}
            </CButton>
          </CCol>
        </CRow>

      </template>
    </CModal>


    <CModal
        :show.sync="addTafziliModal"
        :no-close-on-backdrop="true"
        color="dark"
        :title="$t('addEdit')"
    >

      <CRow>
        <CCol col="12">
          <CInput
              :label="$t('tafsiliTitle')"
              :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
              v-model="edit_group_name"
          />
                                  <CSelect
                                      :label="$t('components.groupNature')"
                                      :options="items_natures"
                                      horizontal
                                      :value.sync="edit_group_nature"
                                  />

                                  <CInput
                                      :label="$t('components.tax')"
                                      :horizontal="{label: 'col-sm-3', input: 'col-sm-3'}"
                                      append="%"
                                      addInput
                                      addInputClasses="text-end"

                                      v-model="edit_group_vat"
                                  />
                                  <CRow class="form-group form-row">
                                    <CCol col="3" style="text-align: end">
                                      <label>{{ $t('components.visibility') }}</label>
                                    </CCol>
                                    <CCol col="9">
                                      <!--                            <CInputCheckbox-->
                                      <!--                                custom-->
                                      <!--:checked.sync="edit_group_visibility"-->
                                      <!--                            />-->
                                      <CIcon
                                          @click.native="edit_group_visibility = 0"
                                          v-if="edit_group_visibility==1"
                                          class="text-success" name="cil-check"/>
                                      <CIcon
                                          @click.native="edit_group_visibility=1"
                                          v-else
                                          name="cil-check"/>

                                    </CCol>
                                  </CRow>
          <CTextarea
              :label="$t('tables.summary')"
              row="2"
              :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
              v-model="edit_group_summary"
          />

        </CCol>
      </CRow>
      <template #footer>
        <CRow class="text-center">
          <CCol style="    text-align: end;">

            <CButton v-if="selected_tafzili!=0" @click="edit_tafzili_data()"
                     class="m-1"
                     color="secondary"
            >{{ $t("buttons.edit") }}
            </CButton>
            <CButton  v-if="(!blocked_moein.includes(edit_refer_person) && !blocked_moein.includes(edit_refer_person_node)) && selected_tafzili==0" @click="insert_tafzili_data()" class="m-1"
                     color="secondary"
            >{{ $t("buttons.add") }}
            </CButton>
            <CButton class="m-1"
                     @click="addTafziliModal = false,selected_tafzili=0"
                     color="secondary"
            >{{ $t("buttons.cancel") }}
            </CButton>
          </CCol>
        </CRow>

      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import 'vue-context/src/sass/vue-context.scss';

import VueContext from 'vue-context';

// import the styles
import VJstree from 'vue-jstree'


export default {
  name: 'Login',
  components: {
    VJstree,
    VueContext
  },
  data() {
    var self = this;

    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

      addGroupModal: false,
      group_code: '',
      group_name: '',
      group_nature: '',
      group_type: '',
      group_vat: '',
      edit_group_vat: '',
      group_parent: 0,
      selected_node_id: 0,
      edit_group_summary:'',
      selected_node_name: '',
      selected_node_parents: '',
      selected_node_floor: 0,
      selected_tafzili:0,
      items_tafsili_types: [],
      items_types: [],
      items_natures: [],
      data_accounting: [],
      data_with_children: [],
      printed_doc_id: 0,
      name: '',
      collapse_tree: false,
      addTafziliModal: false,
      file: '',
      itemEvents: {

        contextmenu: function (node) {
          // console.log()
          // arguments[2].preventDefault()
          self.on_chart_right_clicked(arguments[2], node)
          // self.$refs.menu.open(arguments[2],null)
          // console.log('contextmenu',node.data)
        }
      },
      tafzili_list: [],
      tafzili_fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:1%'},
        {key: 'tafsiliCode', label: this.$t('components.groupCode'), _style: 'width:5%'},
        {key: 'title', label: this.$t('components.groupName'), _style: 'width:10%'},
        {key: 'operation', label: "", _style: 'width:2%'},

      ],
      start_date: '',
      end_date: '',
      submit_refer: 0,
      selected_node:null,
      refer_person: null,
      selected_template: 0,
      edit_group_name: '',
      edit_group_code: '',
      edit_group_nature: 0,
      edit_group_tafsili_type: 0,
      edit_group_visibility: true,
      status_form: 0,
      blocked_moein: [100, 101, 102, 111, 112,10,11,130,300,131,301,141],

      edit_refer_person: 0,
      edit_refer_person_node: 0,
    }
  }, mounted() {

    this.$root.root_validate_errors = [];


    this.get_all_docs();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.selected_tafzili = 0;
      }
    });
  },
  watch: {
    '$route.params.person_id': function () {
      this.get_all_docs();

    },
    'start_date': function () {
      this.get_all_docs();

    },
    'end_date': function () {
      this.get_all_docs();
    }
  },
  methods: {
    get_template_view_pdf(type) {
      var self = this;
      const formData = new FormData();
      var url = "DataViewExport";
      formData.append("Id", type);
      axios.post(url, formData, {responseType: 'blob'}).then(function (response) {

        // var content_data = response.data;
        const href = URL.createObjectURL(response.data);
        console.log(response)
        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        var file_name = response.filename

          file_name = "accountingGroups.xlsx"


        link.setAttribute('download', file_name); //or any other extension
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(href);


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    on_chart_right_clicked(arguments2, node) {
      this.$refs.menu.open(arguments2, null)
      console.log(' clicked !' + node.model.isActive)
      this.selected_node_parents = '';
      this.selected_node_floor = 0;
      this.selected_node_id = node.model.id;
      var objects = this.get_parent(node.model.parentId).reverse();
      for (var i = 0; i < objects.length; i++) {
        if (i != 0) {
          this.selected_node_parents += " - " + objects[i]

        } else {
          this.selected_node_parents += " " + objects[i]

        }
      }
      this.collapse_tree = true;
      this.collapse_tree = false;
      node.model.opened = !node.model.opened
      // node.model.openChildren();
      this.selected_node_name = node.model.accountName;
      this.selected_node = node.model;
      node.selected = true
      console.log(node.model);
      this.edit_group_visibility = node.model.isActive

      this.edit_group_name = node.model.accountName
      this.edit_group_nature = node.model.accNature
      this.edit_group_tafsili_type = node.model.accTafsiliType
      this.edit_group_code = node.model.code
      this.group_type = node.model.accType
      this.edit_refer_person = node.model.parentId
      this.status_form = node.model.id;
      console.log('contextmenu', node.data)
    },
    onClick_context(text) {

      if (text == 'edit') {
        this.addGroupModal = true;
      }

    },

    tree_view_direction() {
      if (this.$i18n.locale == 'fa') {
        return 'tree-rtl text-right'
      }
      if (this.$i18n.locale == 'en') {
        return 'tree-ltr text-left'
      }
    },
    get_parent(itemParentId) {
// if(itemParentId !=0){
      var parents = [];
      this.data_with_children.forEach((val) => {
        if (val.id == itemParentId) {
          this.selected_node_floor++;
          parents.push(val.accountName)
          this.get_parent(val.parentId).forEach((val2) => {
            parents.push(val2)

          });
        }
      });
      return parents;

// }
    },
    // tpl (node, ctx, parent, index, props) {
    itemClick(node) {

      console.log(' clicked !' + node.model.isActive)
      this.selected_node_parents = '';
      this.selected_node_floor = 0;
      this.selected_node_id = node.model.id;
      var objects = this.get_parent(node.model.parentId).reverse();
      for (var i = 0; i < objects.length; i++) {
        if (i != 0) {
          this.selected_node_parents += " - " + objects[i]

        } else {
          this.selected_node_parents += " " + objects[i]

        }
      }
      this.collapse_tree = true;
      this.collapse_tree = false;
      node.model.opened = !node.model.opened
      // node.model.openChildren();
      this.selected_node_name = node.model.accountName;
      node.selected = true
      console.log(node.model);
      this.edit_group_visibility = node.model.isActive

      this.edit_group_name = node.model.accountName
      this.edit_group_nature = node.model.accNature
      this.edit_group_tafsili_type = node.model.accTafsiliType
      this.edit_group_code = node.model.code
      this.group_type = node.model.accType
      this.edit_refer_person = node.model.parentId
      this.edit_refer_person_node = parseInt(node.model.code)
console.log("edit_refer_person_node",this.blocked_moein.includes(this.edit_refer_person_node))
console.log("edit_refer_person",this.blocked_moein.includes(this.edit_refer_person))
      this.status_form = node.model.id;
      if (this.selected_node_floor == 2) {
        this.get_tafzili();

      }
    },
    get_all_docs() {
      this.get_lists_groups();
      this.get_lists_natures();
      this.get_lists_types();
      // this.get_lists_pay();
      this.get_all_systafsili();

    },
    add_sub_row(item) {
      this.group_parent = item.id;

      this.addGroupModal = true;
    },
    go_to_detailed(item) {

      this.$router.push({path: '/dashboard/accounting/detailed-accounting-groups/' + item.id});

    },

    get_lists_groups() {
      var self = this;

      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      self.data_accounting = [];
      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              response.data.data.forEach((val) => {
                if (val.accNature == 1) {
                  val.nature = self.$t('debtor');
                }
                if (val.accNature == 2) {
                  val.nature = self.$t('creditor');
                }
                if (val.accNature == 3) {
                  val.nature = self.$t('neutral');
                }
                if (val.accNature == 0) {
                  val.nature = '';
                }

                if (val.accType == 1) {
                  val.type = self.$t('permanent');
                }
                if (val.accType == 2) {
                  val.type = self.$t('temporary');
                }
                if (val.accType == 0) {
                  val.type = '';
                }
              });
              self.data_with_children = response.data.data;
              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  var obj = {
                    "text": val.accountCode + " " + val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    accType: val.accType,
                    parentId: val.parentId,
                    code: val.accountCode,
                    id: val.id,
                    accountName: val.accountName,
                    accNature: val.accNature,
                    isActive: val.isActive,

                    "opened": false,
                    "icon": "",
                    // "selected":true,
                    children: self.get_childrens(val.id, response.data.data)
                  }
                  self.data_accounting.push(obj);
                }

              });

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

    get_tafzili() {
      var self = this;

      const formData = new FormData();
      var url = "GetAccountTafsiliList";
      formData.append("id", this.status_form);

      self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              self.tafzili_list = response.data.data;

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          var obj = {
            text: val2.accountCode + " " + val2.accountName,
            name_code: val2.accountName + " (" + val2.accountCode + ")",
            code: val2.accountCode,
            id: val2.id,
            children: this.get_childrens(val2.id, list),
            nature: val2.nature,
            type: val2.type,
            accType: val2.accType,
            accountName: val2.accountName,
            isActive: val2.isActive,
            accNature: val2.accNature,

            parentId: val2.parentId,
          }

          array.push(obj);
          // val2.inserted = true;

        }
      });
      return array;
    },
    get_lists_types() {
      var self = this;

      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_SysAccountTypes";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_types = [];
          response.data.data.forEach((val) => {
            var obj = {label: val.accTypeTitle, value: val.accTypeId};
            self.items_types.push(obj);

          });
          self.group_type = response.data.data[0].accTypeId

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_all_systafsili() {
      var self = this;

      const formData = new FormData();
      var url = "GetSysTafsiliTypes";


      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_tafsili_types = [];
          response.data.data.forEach((val) => {
            var obj = {label: val.title, value: val.id};
            self.items_tafsili_types.push(obj);

          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_natures() {
      var self = this;


      const formData = new FormData();
      var url = "Get_SysAccountNatures";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_natures = [];
          response.data.data.forEach((val) => {
            var obj = {label: val.accNatureTitle, value: val.accNatureId};
            self.items_natures.push(obj);

          });
          self.group_nature = response.data.data[0].accNatureId;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.edit_group_name != '') {
        return true;
      }


      // if (this.group_code == 0) {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertCode'));
      // }
      if (this.edit_group_name == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    validateFormEdit: function () {
      this.$root.root_validate_errors = [];

      if (this.edit_group_name != '') {
        return true;
      }


      // if (this.edit_group_code == 0) {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertCode'));
      // }
      if (this.edit_group_name == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      // if (this.status_form == 0) {
      url = "Add_AccountingGroup";
      // } else {
      //   url = "Edit_AccountingGroup";
      // }
      formData.append('AccountId', this.status_form)
      if (this.edit_group_visibility) {
        formData.append('IsActive', 1);

      } else {
        formData.append('IsActive', 0);

      }
      formData.append('LevelNo', this.selected_node_floor + 9);
      formData.append('AccountName', this.edit_group_name);
      formData.append('AccountCode', this.group_code);
      formData.append('AccType', this.group_type);
      formData.append('AccNature', this.edit_group_nature);
      formData.append('AccTafsiliType', this.edit_group_tafsili_type);
      formData.append('ParentId', this.selected_node_id);
      self.addGroupModal = false;

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.group_parent = 0;
        self.selected_node_id = 0;
        self.group_name = '';
        self.group_code = '';
        self.get_all_docs();
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    edit_data() {

      if (!this.validateFormEdit()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      url = "Edit_AccountingGroup";

      formData.append('AccountId', this.status_form)
      formData.append('IsActive', this.edit_group_visibility);
      formData.append('LevelNo', this.selected_node_floor);
      formData.append('AccountName', this.edit_group_name);
      formData.append('AccountCode', this.edit_group_code);

        formData.append('AccNature', this.edit_group_nature);
        formData.append('AccTafsiliType', this.edit_group_tafsili_type);

      if (this.edit_group_nature == null) {
        formData.append('AccType', 0);

      } else {
        formData.append('AccType', this.group_type);
      }
      formData.append('ParentId', this.edit_refer_person);
      self.addGroupModal = false;

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.edit_group_nature = null;
        self.edit_group_visibility = true;
        self.edit_group_name = '';
        self.selected_node_id = 0;
        self.edit_group_code = '';
        self.get_all_docs();
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_tafzili_data() {

      // EditAccountTafsili
      // DeleteAccountTafsili
      //  AccountId
      // Title
      //
      //  Id => inam bara edit v delete
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      // if (this.status_form == 0) {
      url = "AddAccountTafsili";
      // } else {
      //   url = "Edit_AccountingGroup";
      // }
      formData.append('id', 0)

      formData.append('LevelNo', this.selected_node_floor + 8);
      formData.append('Title', this.edit_group_name);
      formData.append('Summary', this.edit_group_summary);
      formData.append('AccountCode', this.group_code);
      formData.append('AccType', this.group_type);
      formData.append('NatureId', this.edit_group_nature);
      formData.append('AccountId', this.status_form);
      formData.append('IsActive', this.edit_group_visibility);
      if(this.edit_group_vat==''){
        formData.append('Vat', "0");
      }else{
        formData.append('Vat', this.edit_group_vat);
      }
      self.addTafziliModal = false;

      axios.post(url, formData, {}).then((res) => {

        // self.status_form = 0;
        // self.group_parent = 0;
        self.edit_group_summary = '';
        // self.selected_node_id = 0;
        // self.group_name = '';
        // self.group_code = '';
        self.get_tafzili();
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    edit_tafzili_data() {

      if (!this.validateFormEdit()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      url = "EditAccountTafsili";

      formData.append('id', this.selected_tafzili)

      formData.append('LevelNo', this.selected_node_floor);
      formData.append('Title', this.edit_group_name);
      formData.append('Summary', this.edit_group_summary);
      formData.append('AccountCode', this.edit_group_code);
      formData.append('AccType', this.group_type);
      formData.append('NatureId', this.edit_group_nature);
      formData.append('IsActive', this.edit_group_visibility);
      if(this.edit_group_vat==''){
        formData.append('Vat', "0");
      }else{
        formData.append('Vat', this.edit_group_vat);
      }
      formData.append('AccountId', this.edit_refer_person);
      self.addTafziliModal = false;

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {


        self.selected_tafzili = 0;

        self.get_tafzili();
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
edit_tafzili(item){
  this.selected_tafzili=item.recId;
  this.edit_group_nature= item.natureId;
  this.edit_group_name=item.title;
  this.edit_group_summary=item.summary;
  this.addTafziliModal=true
  this.edit_group_vat=item.vat
  this.edit_group_visibility=item.isActive
  if(this.edit_group_nature==0){
    this.edit_group_nature = this.items_natures[0].value;
  }
},
    add_tafzili(){
      this.addTafziliModal=true;
      this.edit_group_name=''
          this.edit_group_summary=''
      this.edit_group_nature=this.selected_node.accNature
      this.edit_group_visibility=1;
      this.edit_group_vat=0;
  if(this.edit_group_nature==0){
    this.edit_group_nature = this.items_natures[0].value;
  }
},
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.boxTitle]), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.selected_tafzili = item.recId;

    },
    delete_item() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteAccountTafsili";
      formData.append('Id', this.selected_tafzili);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.selected_tafzili =0;
        self.get_tafzili();

      })
          .catch(function (error) {

            console.log(error);
          });
    },
  },

}

</script>
<style>
.zk-table__cell-inner {
  text-align: initial;
}

.tree-default .tree-themeicon {
  display: none;
}

.tree-default > .tree-wholerow-ul .tree-hovered, .tree-default > .tree-wholerow-ul .tree-selected {
  background: gray !important;

}
</style>
